import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const Users = lazy(() => import('./view/mobile/users'))
const Actions = lazy(() => import('./view/mobile/actions'))
const Account = lazy(() => import('./view/mobile/account'))
const Closed = lazy(() => import('./view/mobile/actions/closed'))
const Trash = lazy(() => import('./view/mobile/actions/trash'))
const Password = lazy(() => import('./view/mobile/config/password'))

const RoutesMobile = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch() 

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
                    <Route exact path="/gateway-payment" component={Account} />
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/supporters" component={Users} />
                    <Route exact path="/actions" component={Actions} />
                    <Route exact path="/actions/closed" component={Closed} />
                    <Route exact path="/actions/trash" component={Trash} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/" component={Actions} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default RoutesMobile;